import PageLayout from '@/components/PageLayout';
import Press from '@/components/Search/Press';
import Products from '@/components/Search/Products';
import Supports from '@/components/Search/Supports';
import { useGlobal } from '@/utils/useGlobal';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import { Skeleton, Tabs } from 'antd';
import css from './search.module.scss';
//import { EFHeaderSearch, EFHeaderSearchForSearch } from '@/components/UI/svg/Header';
import SEOlinksA from '@/components/SEOlinksA';
import Image from '@/components/UI/Image';
import EFHeaderSearch from '@/components/UI/svg/Header/Icon/EFHeaderSearch';
import EFHeaderSearchForSearch from '@/components/UI/svg/Header/Icon/EFHeaderSearchForSearch';
import seoconfig from '@/seoconfig/search';
import { getSearchRes } from '@/service';
const { TabPane } = Tabs;

export default function Search({ keyword, SEO }: any) {
    const { useState, useEffect, useLang, isMobile, useRouter, gtm } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const [searchRes, setSearchRes] = useState({}); // 返回数据
    const [count, setCount] = useState({
        products: 0,
        press: 0,
        support: 0,
        total: 0,
    }); // 各个tab的数量以及总数
    const [loading, setLoading] = useState(false); // loading
    const [value, setValue] = useState('');
    const [currentKey, setCurrentKey] = useState('products');
    const { t } = useLang('shared');

    const KEY_MAP = {
        blog: 'EcoFlow Blog',
        faq: 'FAQ',
        products: 'Product',
    };

    // 计算res各项total
    const calculateTotal = (searchRes: any) => {
        const res: any = { total: 0 };
        Object.keys(searchRes).forEach((key) => {
            res[key] = searchRes[key].length;
            res['total'] += res[key];
        });
        res.blog = res.news + res.supports;
        return res;
    };

    // 获取search接口res
    const handleSearch = async (keyWord: string) => {
        setLoading(true); // 打开loading
        try {
            const res: any = await getSearchRes({
                keyWord,
                searchScope: 'products,faq,supports',
            });
            setLoading(false); // 关闭loading
            if (res.code === '0') {
                setSearchRes(res.data || {});
                setCount({ ...count, ...calculateTotal(res.data) });
                return;
            }
        } catch (e) {
            setLoading(false); // 关闭loading
            console.log('e', e);
        }
    };

    // 切换tab
    const handleChangeTabs = (key: string) => {
        const navigationName = KEY_MAP[key];
        if (navigationName)
            gtm.push({
                event: 'uaEvent',
                event_name: 'search_navigation',
                navigation_name: navigationName,
            });
        setCurrentKey(key);
    };

    // 点击搜索
    const onEnter = (e: any) => {
        const keyword = e.target.value;
        if (e.keyCode !== 13 || !keyword) return;
        gtm.push({
            event: 'uaEvent',
            event_name: 'search',
            search_term: keyword,
            button_name: '',
            type: 'Enter',
        });
        router.push('/search/[keyword]', `/${locale}/search/${keyword}`);
    };

    // 输入框change
    const handleChange = (e: any) => {
        const value = e.target.value;
        setValue(value);
    };

    // 清空输入框
    const clearValue = () => {
        setValue('');
    };

    useEffect(() => {
        handleSearch(keyword || '').catch();
        setValue(keyword);

        gtm.EmPush(['searchTerm', keyword]);
    }, [keyword]);

    const titleMap: any = {
        river: t('searchkeyword.seo_title_river'),
        delta: t('searchkeyword.seo_title_delta'),
    };

    return (
        <PageLayout>
            <SEO title={titleMap[keyword] || titleMap.river} description={''} />
            <SEOlinksA locale={locale} list={seoconfig[keyword]?.include} pathname={seoconfig[keyword]?.url} />
            <div className={`${css.search} page-search`}>
                {/* 搜索区域 */}
                <div className="searchBarContainer searchBarContainer-pc">
                    <div className="searchBackground">
                        <Image className="backImg" src="/img/search/searchBackground.jpg" layout="fill" alt={t('searchkeyword.title')} />
                    </div>
                    <div className="searchBarContent">
                        <input value={value} onChange={handleChange} onKeyDown={onEnter} type="text" aria-label={t('searchkeyword.title')} />
                        {/* 搜索与关闭图标 */}
                        <div className="searchIcon">
                            <EFHeaderSearch />
                        </div>
                        {!!value && (
                            <div className="closeIcon" onClick={clearValue}>
                                <CloseOutlined />
                            </div>
                        )}
                    </div>
                </div>
                {/* 搜索区域-h5 */}
                <div className="searchBarContainer searchBarContainer-h5">
                    <div className="ef-input-search-primal">
                        <input
                            value={value}
                            onChange={handleChange}
                            onKeyDown={onEnter}
                            type="text"
                            className="ef-input-search-primal-input"
                            placeholder={t('searchkeyword.search_web')}
                            aria-label={t('searchkeyword.search_web')}
                        />
                        {/* 搜索与关闭图标 */}
                        <div className="ef-input-search-primal-searchicon">
                            <EFHeaderSearchForSearch />
                        </div>
                        {!!value && (
                            <div className="ef-input-search-primal-closeicon" onClick={clearValue}>
                                <CloseOutlined />
                            </div>
                        )}
                    </div>
                </div>

                {/* 内容区域 */}
                <div className="searchResContainer">
                    <Tabs
                        onChange={handleChangeTabs}
                        activeKey={currentKey}
                        tabBarExtraContent={
                            <span className="leftTotalRes">
                                {t('searchkeyword.site_search_result', {
                                    number: count.total || 0,
                                })}
                            </span>
                        }
                    >
                        <TabPane
                            tab={`${isMobile ? t('searchkeyword.site_search_products') : t('searchkeyword.site_search_product')}${
                                isMobile ? '' : `(${count.products || 0})`
                            }`}
                            key="products"
                        >
                            {!loading ? <Products products={searchRes.products} isMobile={isMobile} /> : <Skeleton />}
                        </TabPane>
                        {!['eu', 'br', 'mx'].includes(locale) && (
                            <TabPane
                                tab={`${isMobile ? t('searchkeyword.site_search_press') : t('searchkeyword.site_search_blog')}${
                                    isMobile ? '' : `(${count.supports + count.news || 0})`
                                }`}
                                key="blog"
                            >
                                {!loading ? <Press press={searchRes.supports} news={searchRes.news} isMobile={isMobile} /> : <Skeleton />}
                            </TabPane>
                        )}

                        <TabPane tab={`${t('searchkeyword.site_search_faq')}${isMobile ? '' : `(${count.faq || 0})`}`} key="faq">
                            {!loading ? <Supports faqs={searchRes.faq} isMobile={isMobile} /> : <Skeleton />}
                        </TabPane>
                    </Tabs>
                    {!!count[currentKey] && !isMobile && <p className="endRes font-family-regular">{t('searchkeyword.site_search_result_end')}</p>}
                    {!!count[currentKey] && isMobile && (
                        <p
                            className="endRes font-family-regular"
                            style={{
                                marginTop: currentKey === 'products' ? '.59rem' : currentKey === 'faq' ? '.805rem' : '.48rem',
                            }}
                        >
                            {t('searchkeyword.site_search_result_end_tab', {
                                number:
                                    currentKey === 'products'
                                        ? count.products || 0
                                        : currentKey === 'faq'
                                        ? count.faq || 0
                                        : currentKey === 'blog'
                                        ? count.supports + count.news || 0
                                        : 0,
                            })}
                        </p>
                    )}
                </div>
            </div>
        </PageLayout>
    );
}

export const getServerSideProps = async ({ params }: any) => {
    const keyword = params.keyword;
    return {
        props: { keyword },
    };
};
